"use strict";
import React, {Component} from "react";
import {PropTypes, RenderContent} from "Subschema";

export default class SkipLink extends Component {


    static displayName = 'SkipLink';

    static template = false;

    static propTypes = {
        onClick: PropTypes.func,
        onChange: PropTypes.valueEvent,
        content: PropTypes.content,
        primary: PropTypes.bool,
        hard: PropTypes.bool,
        href: PropTypes.string,
        label: PropTypes.content,
        className: PropTypes.string,
        id: PropTypes.string,
        style: PropTypes.style,
        name: PropTypes.string,
        createUpdateReady: PropTypes.bool,
        createUpdateReadyPath: PropTypes.string,
        intentSubtype: PropTypes.string,
        action: PropTypes.string,
		actionName: PropTypes.string,
        skipValidation: PropTypes.bool,
        trackingClickData: PropTypes.object,
        btnConfirmEnabled: PropTypes.bool,
        onBtnConfirmClick: PropTypes.valueEvent
    };

    static defaultProps = {
        action: "submit",
        createUpdateReady: false,
        intentSubtype: "submit",
        onChange: "_intent",
        skipValidation: false,
        btnConfirmEnabled: false
    };

    static injetedProps = {
        onBtnConfirmClick: "_internal.btnSkipClicked"
    };

    constructor(props, ...rest) {
        super(props, ...rest);
        this.setupValue(props);
    }

    componentWillReceiveProps(props) {
        this.setupValue(props);
    }

    setupValue(props) {
        const {createUpdateReadyPath, createUpdateReady, intentSubtype, skipValidation, actionName} = props;
        this.value = `${JSON.stringify({
            createUpdateReadyPath,
            createUpdateReady,
            intentSubtype,
            skipValidation,
			actionName
        })}`;
    }

    buttonOnClick = (e)=> {

        const {trackingClickData} = this.props;

        if (window.fpti && window.PAYPAL && window.PAYPAL.analytics && window.PAYPAL.analytics.instance) {

            Object.assign(window.fpti || (window.fpti = {}), trackingClickData);

            PAYPAL.analytics.instance.recordClick();
        }

        if (this.props.btnConfirmEnabled) {
            this.props.onBtnConfirmClick(true);

            if (e && e.preventDefault) {
                e.preventDefault();
            }
        } else{
            this.props.onChange(this.value);
            if (this.props.onClick) {
                var validate = !this.props.skipValidation && this.props.intentSubtype && this.props.intentSubtype === 'submit' ? true : false;
                this.props.onClick(e, this.props.action, validate);
            }
        }
    };

    renderLink() {
        const {content, primary, label, primaryLinkClass, secondaryLinkClass='', name='', id='', href} = this.props;
        const btnContent = content || label;
        return <span className={primary ? primaryLinkClass : secondaryLinkClass}>
            <a href={href} name={name} id={id}>
                { !btnContent ? null : <RenderContent content={btnContent}/> }
            </a>
        </span>
    }
    renderBtn() {
        const {content, primary, label, primaryClass, buttonAsLinkClass='', name='', id=''} = this.props;
        const btnContent = content || label;
        return <button className={primary ? primaryClass : buttonAsLinkClass} name={name} id={id}
                       value={this.value}
                       onClick={this.buttonOnClick}>
            { !btnContent ? null : <RenderContent content={btnContent}/> }
        </button>
    }

    render() {
        //We will wrap the non primary buttons, so that first-of-type will work correctly.   For 3 button layouts.
        return this.props.hard ? this.renderLink() : this.props.primary ? <span>{this.renderBtn()}</span> : this.renderBtn();
    }
}



/** WEBPACK FOOTER **
 ** ./src/types/skipLinks/SkipLink.jsx
 **/